var _defs, _use, _path, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "AnimatedIcon__icon",
    width: 96,
    height: 96,
    preserveAspectRatio: "xMinYMin",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    "data-js-controller": "HealthIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "healthIconCircle",
    cx: 35,
    cy: 49,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    id: "healthIconCheck",
    d: "M47 28a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm3.94 4.73L45 38.78 43.43 37a.83.83 0 0 0-1.3 1L44 41.2a1 1 0 0 0 1.7 0c.3-.41 6-7.57 6-7.57.75-.8-.16-1.51-.76-.9z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "healthIconLineClipPath"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 49,
    r: 17
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "healthIconCircleClipPath"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#healthIconCircle"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "healthIconCircle",
    cx: 35,
    cy: 49,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    id: "healthIconCircle",
    cx: 35,
    cy: 49,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    id: "healthIconCheck",
    d: "M47 28a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm3.94 4.73L45 38.78 43.43 37a.83.83 0 0 0-1.3 1L44 41.2a1 1 0 0 0 1.7 0c.3-.41 6-7.57 6-7.57.75-.8-.16-1.51-.76-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "healthIconCheck",
    d: "M47 28a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm3.94 4.73L45 38.78 43.43 37a.83.83 0 0 0-1.3 1L44 41.2a1 1 0 0 0 1.7 0c.3-.41 6-7.57 6-7.57.75-.8-.16-1.51-.76-.9z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#healthIconCircle",
    fill: "#80E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "HealthIcon__line",
    d: "M16 53h6l2.5-6L29 59l5-20.5L37 53l19 .09",
    clipPath: "url(#healthIconLineClipPath)",
    "data-js-target": "HealthIcon.line",
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: "2px"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    className: "HealthIcon__check",
    href: "#healthIconCheck",
    fill: "#7A73FF",
    "data-js-target-list": "HealthIcon.checks"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    className: "HealthIcon__check",
    href: "#healthIconCheck",
    fill: "#0048E5",
    clipPath: "url(#healthIconCircleClipPath)",
    "data-js-target-list": "HealthIcon.checks"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.bb54f3ae615c98ccfac179e0fe346a6a.svg";
export { ForwardRef as ReactComponent };